import { InternalFilesFolderPageHeaderQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import DocumentsResourceHeader from 'modules/documents/components/DocumentsResourceHeader'
import { getTitle } from 'modules/documents/lib/Folders'

export type Folder =
  InternalFilesFolderPageHeaderQuery['documents']['ancestors']['edges'][number]['node']
export type Policies = InternalFilesFolderPageHeaderQuery['documents']['_policies']

interface Props {
  folder: NonNullable<Folder>
  policies: Policies
}

const FolderDocumentsPageHeader = ({ folder, policies }: Props) => {
  const { navigation } = useNavigation()

  const title = getTitle(folder.name)

  const canUploadDocument =
    policies?.companyEditInternalDocuments?.can || policies?.companyUseCompanyDocuments?.can

  const url = navigation.files.managementDocuments.folderId.new.fullPath({ folderId: folder.id })

  return <DocumentsResourceHeader title={title} canUploadDocument={canUploadDocument} url={url} />
}

export default FolderDocumentsPageHeader
